"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var VrpAutoDispatchAnalyticEntity_1 = __importDefault(require("./Entity/VrpAutoDispatchAnalyticEntity"));
var VrpAutoDispatchAnalyticApi = /** @class */ (function () {
    function VrpAutoDispatchAnalyticApi(session) {
        this.vrpAutoDispatchAnalyticEntity = new VrpAutoDispatchAnalyticEntity_1.default(session);
    }
    VrpAutoDispatchAnalyticApi.prototype.getAll = function (queryString) {
        return this.vrpAutoDispatchAnalyticEntity.service.getAll(queryString);
    };
    VrpAutoDispatchAnalyticApi.prototype.onDoneEvent = function (eventHandler) {
        this.vrpAutoDispatchAnalyticEntity.onDoneEvent = eventHandler;
    };
    VrpAutoDispatchAnalyticApi.prototype.getTeamsStates = function () {
        return this.vrpAutoDispatchAnalyticEntity.getTeamsStates();
    };
    return VrpAutoDispatchAnalyticApi;
}());
exports.default = VrpAutoDispatchAnalyticApi;
//# sourceMappingURL=VrpAutoDispatchAnalyticApi.js.map